"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get Author () {
        return Author;
    },
    get BulkFeedbackCreateSchema () {
        return BulkFeedbackCreateSchema;
    },
    get BulkFeedbackRequestSchema () {
        return BulkFeedbackRequestSchema;
    },
    get BulkFeedbackResponseSchema () {
        return BulkFeedbackResponseSchema;
    },
    get CompanyFeedbackFiltersSchema () {
        return CompanyFeedbackFiltersSchema;
    },
    get CompanyFeedbackQuerySchema () {
        return CompanyFeedbackQuerySchema;
    },
    get CustomFieldValue () {
        return CustomFieldValue;
    },
    get FEEDBACK_MESSAGE_MAX_LENGTH () {
        return FEEDBACK_MESSAGE_MAX_LENGTH;
    },
    get FEEDBACK_REQUEST_COOLDOWN_DAYS () {
        return FEEDBACK_REQUEST_COOLDOWN_DAYS;
    },
    get Feedback () {
        return Feedback;
    },
    get MAX_BULK_FEEDBACK_RECIPIENTS () {
        return MAX_BULK_FEEDBACK_RECIPIENTS;
    },
    get Subject () {
        return Subject;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _generic = require("../generic");
const FEEDBACK_MESSAGE_MAX_LENGTH = 560;
const MAX_BULK_FEEDBACK_RECIPIENTS = 5000;
const FEEDBACK_REQUEST_COOLDOWN_DAYS = 14;
const Author = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    name: _zod.z.string()
});
const CustomFieldValue = _zod.z.object({
    field_name: _zod.z.string(),
    value: _zod.z.unknown(),
    displayValue: _zod.z.string().optional()
});
const Subject = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    custom_field_values: _zod.z.record(_zod.z.string(), CustomFieldValue)
});
const Feedback = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    author: _zod.z.array(Author),
    categories: _zod.z.array(_zod.z.string()).optional(),
    content: _zod.z.string().optional(),
    feedback_message: _zod.z.string().optional(),
    last_updated: _zod.z.string(),
    request_message: _zod.z.string().optional(),
    response_to_request: _zod.z.boolean().optional(),
    shared_with: _models.FeedbackSharedWithModel,
    subject: _zod.z.array(Subject),
    deleted: _zod.z.boolean().optional(),
    feedback_request: _zod.z.boolean().optional()
});
const CompanyFeedbackQuerySchema = _zod.z.object({
    authorId: _zod.z.string().optional(),
    subjectId: _zod.z.string().optional(),
    sharedWith: _zod.z.string().optional(),
    categories: _zod.z.string().optional(),
    dateAfter: _zod.z.string().optional(),
    dateBefore: _zod.z.string().optional(),
    searchTerm: _zod.z.string().optional(),
    customFieldIds: _zod.z.string().optional(),
    responseToRequest: _zod.z.enum([
        "true",
        "false"
    ]).transform((v)=>v === "true").optional()
});
const CompanyFeedbackFiltersSchema = _zod.z.object({
    authorId: _zod.z.string().optional(),
    subjectId: _zod.z.string().optional(),
    sharedWith: _zod.z.string().optional(),
    categories: _zod.z.array(_zod.z.string()).optional(),
    dateAfter: _zod.z.string().optional(),
    dateBefore: _zod.z.string().optional(),
    searchTerm: _zod.z.string().optional(),
    customFieldIds: _zod.z.array(_zod.z.string()).optional(),
    responseToRequest: _zod.z.boolean().optional()
});
const BulkFeedbackRequestSchema = _zod.z.object({
    recipientIds: _zod.z.array(_utilsisomorphic.transformObjectId).min(1).max(MAX_BULK_FEEDBACK_RECIPIENTS),
    message: _zod.z.string().max(FEEDBACK_MESSAGE_MAX_LENGTH).optional()
});
const BulkFeedbackCreateSchema = _zod.z.object({
    subjectIds: _zod.z.array(_utilsisomorphic.transformObjectId).min(1).max(MAX_BULK_FEEDBACK_RECIPIENTS),
    sharedWith: _models.FeedbackSharedWithModel.default("me"),
    content: _zod.z.string(),
    feedbackMessage: _zod.z.string().min(1),
    feedbackRequestId: _utilsisomorphic.transformObjectId.optional()
});
const BulkFeedbackResponseSchema = _generic.GenericTaskIdResponse;
